import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reset, change } from 'redux-form';
import { useMutation } from '@apollo/client';

import { withFlashMessages } from 'components/FlashMessages';
import { processHoneypot } from 'utils/forms';
import { Dispatch } from 'types';
import { ContactFormFields } from 'components/forms/ContactForm/types';
import { useTranslation } from 'lib/i18n';
import {
  SendContactFormMessageMutation,
  SendContactFormMessageMutationVariables,
} from 'types/graphql';

import { FORM_ID } from './constants';
import SEND_CONTACT_FORM_MESSAGE_MUTATION from './mutations/sendContactFormMessage';
import Form from './composeForm';
import { ContactFormMapDispatch, ContactFormProps } from './types';

const ContactForm: React.FC<ContactFormProps> = props => {
  const [mutate] = useMutation<
    SendContactFormMessageMutation,
    SendContactFormMessageMutationVariables
  >(SEND_CONTACT_FORM_MESSAGE_MUTATION);
  const { t, i18n } = useTranslation('forms');

  useEffect(() => {
    const { organizationsDemo, dispatch } = props;
    if (organizationsDemo) {
      dispatch(
        change(FORM_ID, 'message', t('contactForm.organizationsDemoMessage')),
      );
    }
  });

  const handleSuccess = (): void => {
    props.resetForm();
    props.showFlashMessage(t('contactForm.success'), {
      type: 'success',
    });
  };

  const handleError = (): void => {
    props.showFlashMessage(t('contactForm.error'), {
      type: 'danger',
    });
  };

  const handleSubmit = (_variables: unknown): void => {
    const variables = _variables as ContactFormFields;
    processHoneypot(variables);

    mutate({ variables })
      .then(() => {
        handleSuccess();
      })
      .catch(() => {
        handleError();
      });
  };

  return <Form id={FORM_ID} i18n={i18n} t={t} onSubmit={handleSubmit} />;
};

const mapDispatchToProps = (dispatch: Dispatch): ContactFormMapDispatch => ({
  resetForm: () => dispatch(reset(FORM_ID)),
  dispatch,
});

export default connect(
  null,
  mapDispatchToProps,
)(withFlashMessages(ContactForm));
